import { useMutation } from "@tanstack/react-query";
import { apiClient } from "../../../../lib/api-client";
import { RetailOrderUpdateType, UpdateRetailOrderParams } from "../types/UpdateRetailOrderParams";
import { UpdateRetailOrderResult } from "../types/UpdateRetailOrderResult";


export const useUpdateRetailOrder = (
	params: UpdateRetailOrderParams,
	onSuccess: (result: UpdateRetailOrderResult) => void,
	onError: (error: string) => void) => {

	let method = '';
	let requestParams: any;
	switch (params.updateType) {
		case RetailOrderUpdateType.Info:
			method = 'update-info';
			requestParams = {
				retailOrderID: params.ro.retailOrderID,
				cabinetDate: params.ro.cabinetDate,
				projectManager: params.ro.projectManager,
				psiProject: params.ro.psiProject,
				cabinetFlag: params.ro.cabinetFlag,
			};
			break;
		case RetailOrderUpdateType.CustomerContact:
			method = 'submit-contact';
			requestParams = {
				retailOrderID: params.ro.retailOrderID,
				customerContactDate: params.ro.customerContactDate
			};
			break;
		case RetailOrderUpdateType.ReadyToMeasureOrTemplate:
			method = 'submit-readyto';
			requestParams = {
				retailOrderID: params.ro.retailOrderID,
				readyToMeasureOrTemplateDate: params.ro.readyToMeasureOrTemplateDate
			};
			break;
		case RetailOrderUpdateType.Template:
			method = 'submit-template';
			requestParams = {
				retailOrderID: params.ro.retailOrderID,
				readyToMeasureOrTemplateDate: params.ro.readyToMeasureOrTemplateDate,
				measureDate: params.ro.measureDate,
				enterTemplateDate: params.ro.enterTemplateDate,
				templateRescheduleReasonID: params.ro.templateRescheduleReasonID,
				measurer: params.ro.measurer,
				templater: params.ro.templater
			}
			break;
		case RetailOrderUpdateType.Schedule:
			method = 'submit-schedule';
			requestParams = {
				retailOrderID: params.ro.retailOrderID,
				scheduledInstallDate: params.ro.scheduledInstallDate,
				scheduledDeliveryDate: params.ro.scheduledDeliveryDate,
				rescheduleReasonID: params.ro.rescheduleReasonID,
				installer: params.ro.installer,
				deliveryBy: params.ro.deliveryBy,
				scheduledInstallStartDate: params.ro.scheduledInstallStartDate,
				scheduledInstallCompletionDate: params.ro.scheduledInstallCompletionDate
			};
			break;
		case RetailOrderUpdateType.Install:
			method = 'submit-install';
			requestParams = {
				retailOrderID: params.ro.retailOrderID,
				actualInstallDate: params.ro.actualInstallDate,
				deliveryDate: params.ro.deliveryDate
			};
			break;
		case RetailOrderUpdateType.InstallStart:
			method = 'actual-install-start-date';
			requestParams = {
				retailOrderID: params.ro.retailOrderID,
				actualInstallStartDate: params.ro.actualInstallStartDate
			};
			break;			
		case RetailOrderUpdateType.LowerCabinets:
			method = 'lower-cabinets-plumb-level-date';
			requestParams = {
				retailOrderID: params.ro.retailOrderID,
				lowerCabinetsPlumbLevelDate: params.ro.lowerCabinetsPlumbLevelDate
			};
			break;
		case RetailOrderUpdateType.InstallCompletion:
			method = 'actual-install-completion-date';
			requestParams = {
				retailOrderID: params.ro.retailOrderID,
				actualInstallCompletionDate: params.ro.actualInstallCompletionDate
			};
			break;
		case RetailOrderUpdateType.ActualMeasure:
			method = 'submit-actual-measure';
			requestParams = {
				retailOrderID: params.ro.retailOrderID,
				actualMeasureDate: params.ro.actualMeasureDate
			};
			break;

		case RetailOrderUpdateType.POReceived:
			method = 'submit-po-received-date';
			requestParams = {
				retailOrderID: params.ro.retailOrderID,
				cabinetPOReceivedDate: params.ro.cabinetPOReceivedDate
			};
			break;

		case RetailOrderUpdateType.PlumbingSchedule:
			method = 'submit-plumbing-schedule';
			requestParams = {
				retailOrderID: params.ro.retailOrderID,
				readyForDisconnectDate: params.ro.readyForDisconnectDate,
				readyForReconnectDate: params.ro.readyForReconnectDate,
				scheduledDisconnectDate: params.ro.scheduledDisconnectDate,
				scheduledReconnectDate: params.ro.scheduledReconnectDate
			};
	}

	const { mutate, isLoading } = useMutation({
		mutationFn: async () => {
			return await apiClient.post("retail-order/" + method, requestParams) as UpdateRetailOrderResult;
		},
		onSuccess: async (result) => {
			if (result.isSuccess)
				onSuccess(result);
			else
				onError('Error when updating the retail order: ' + result.errorMessage!);
		},
		onError(error) {
			onError(error as string);
		}
	});

	return {
		mutate, isLoading
	}
}
